import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './fonts/fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


/* const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); */

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
